// Module
var code = "<div class=\"view-upload\"> <upload-classic nav-class=\"navbar-default navbar-inverse app-subheader\" on-cancel=\"$ctrl.cancel()\" on-submit=\"$ctrl.submit()\" options=\"$ctrl.options\"></upload-classic> </div> ";
// Exports
export default code;